const BASE_URL =
  process.env.REACT_APP_BASE_URL ||
  (process.env.NODE_ENV === 'production' ? window.location.origin : 'http://localhost:8080');
const API_VERSION = '/api/v1'

export const API_BASE_URL = `${BASE_URL}${API_VERSION}`;
